module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/copy-sync/index.js
// module id = 573
// module chunks = 0 1 2